
import React from 'react';
import Image from '@/components/ui/image';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import KayttokohteetCard from '@/components/home/KayttokohteetCard';

interface RenovationImageProps {
  url: string;
  title: string;
  description: string;
}

// Gallery component for renovation images
const RenovationImageGallery: React.FC = () => {
  const renovationImages: RenovationImageProps[] = [
    {
      url: "/lovable-uploads/18e84364-d835-4591-a0ff-3c7deafc1ccf.png",
      title: "Portaikot",
      description: "Tyylikäs kulkureitti kotisi kerroksien välillä"
    },
    {
      url: "/lovable-uploads/231b3848-9a36-453f-9be8-5e3fd5709abb.png",
      title: "Työympäristöt",
      description: "Toimivat ja mukavat työtilat elämiseen"
    },
    {
      url: "https://images.unsplash.com/photo-1600494603989-9650cf6ddd3d?auto=format&fit=crop&w=600&q=80",
      title: "Minimalismi",
      description: "Selkeät ja modernit tilaratkaisut"
    },
    {
      url: "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=600&q=80",
      title: "Energiaratkaisut",
      description: "Ympäristöystävälliset kodin ratkaisut"
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      {renovationImages.map((image, index) => (
        <KayttokohteetCard
          key={index}
          title={image.title}
          description={image.description}
          imagePath={image.url}
        />
      ))}
    </div>
  );
};

export default RenovationImageGallery;
